import React, { useMemo, useState } from "react";
import { FormattedMessage } from "react-intl";

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";

import { SearchBar } from "../../../components/SearchBar";
import { useDataSets } from "../../dashboard-view/api/useDatasets";
import { NoResult } from "../../dashboard-view/components/NoResult";
import { useDatasetUpdate } from "../api/useDatasetUpdate";

import { DatasetsTableRow } from "./DatasetsTableRow";

const cellStyles = {
  fontWeight: "bold",
  backgroundColor: "#A6B1B7",
  color: "#ffffff!important",
  height: "60px",
  width: "33%",
};

const tableStyles = {
  minWidth: 650,
};

export type EditedField = {
  row: number;
  column: string;
};

export function DatasetsTable({ ...props }) {
  const { datasets } = useDataSets();

  const [searchPhase, setSearchPhase] = useState("");
  const [editedData, setEditedData] = useState<null | EditedField>();

  const closeEditMode = () => {
    setEditedData(null);
  };

  const filteredDatasets = useMemo(
    () =>
      (datasets?.Datasets || []).filter(d =>
        d?.Name?.toLowerCase().includes(searchPhase.toLowerCase()),
      ),
    [searchPhase, datasets],
  );
  const { updateDataset } = useDatasetUpdate({ onSuccess: closeEditMode });

  const handleDataUpdate = (data: {
    id?: number | undefined | null;
    name?: string | undefined | null;
    owner?: string | null;
  }) => {
    updateDataset(data);
  };

  return (
    <div {...props}>
      <div className="p-4 border-[1px] border-solid border-gray-200 rounded mt-4">
        <div className="mt-4">
          <SearchBar
            placeholder="Search by dataset name"
            searchIcon
            onChange={value => {
              setSearchPhase(value);
            }}
          />
        </div>

        <div className="mt-6">
          <Table sx={tableStyles} aria-label="simple base-table">
            <TableHead>
              <TableRow>
                <TableCell sx={cellStyles}>
                  <FormattedMessage
                    id="DATASET_TABLE.DATASET"
                    description="Dataset column in dataset table"
                    defaultMessage="Dataset"
                  />
                </TableCell>
                <TableCell sx={cellStyles}>
                  <FormattedMessage
                    id="DATASET_TABLE.OWNER"
                    description="Owner column in dataset table"
                    defaultMessage="Owner"
                  />
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredDatasets.length ? (
                filteredDatasets.map(dataset => (
                  <DatasetsTableRow
                    key={dataset.Id}
                    data={dataset}
                    onEdit={(data, column) =>
                      setEditedData({ row: data.Id!, column: column })
                    }
                    onSave={handleDataUpdate}
                    editedField={editedData}
                    onCancel={() => setEditedData(null)}></DatasetsTableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={4}>
                    <NoResult />
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </div>
      </div>
    </div>
  );
}
